import { render } from "./ProfileThemeEight.vue?vue&type=template&id=450b0e4d"
import script from "./ProfileThemeEight.vue?vue&type=script&lang=js"
export * from "./ProfileThemeEight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/themes/old_layouts/ProfileThemeEight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "450b0e4d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('450b0e4d', __exports__)) {
    api.reload('450b0e4d', __exports__)
  }
  
  module.hot.accept("./ProfileThemeEight.vue?vue&type=template&id=450b0e4d", () => {
    api.rerender('450b0e4d', render)
  })

}


export default __exports__